import {spacing} from "@khanacademy/wonder-blocks-tokens";

const shapeCloudPurplePath =
    "/images/coach/slideshow-assets/shape-cloud-purple.png";
const shapeQuadrilateralPurplePath =
    "/images/coach/slideshow-assets/shape-quadrilateral-purple.png";
const shapeBoulderPurplePath =
    "/images/coach/slideshow-assets/shape-boulder-purple.png";

export const shapes = [
    shapeBoulderPurplePath,
    shapeCloudPurplePath,
    shapeQuadrilateralPurplePath,
];
export const slideW = 10;
export const slideH = 5.625;
export const padding = spacing.xLarge_32 / 72;

// NOTE: These colors map to the Wonder Blocks default color primitives.
export const purple = "EADCFF";
export const darkBeige = "F3E6D1";
export const blueLink = "1865F2";
export const blue = "C8D9F8";
export const blueBlooket = "D7FCFF";
export const black = "21242C";

export const defaultUnderlineOptions = {style: "dash", color: black} as const;

export const toInches = (pixels: number) => {
    const ppi = 72;
    return pixels / ppi;
};

export const paragraphAfter = toInches(spacing.xLarge_32);
export const lineSpacing = 1.2;
export const textBodyMaxW = (slideW - 2 * padding) * 0.75;

export const qTextY = 1;
export const h3Size = 12;
